import styles from '@/components/Common/FormItem/FormItem.styles';
import {
  HelperTextType,
  InputProps,
} from '@/components/Common/FormItem/FormItem.utils';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import InputHelperText from '../InputHelperText/InputHelperText';

export default function FormItem({
  label,
  children,
  sx,
  helperText,
  helperTextType = HelperTextType.Error,
}: InputProps) {
  return (
    <Box sx={{ ...styles.wrapper, ...sx }}>
      {label && <Typography sx={styles.label}>{label}</Typography>}
      {children}
      {helperText && (
        <InputHelperText message={helperText} helperTextType={helperTextType} />
      )}
    </Box>
  );
}
